const firebaseConf = {
	FbApiKey: 'AIzaSyC_xU-keic4zlogdimiPaLiyWH4IB5gmIQ',
	FbAuthDomain: 'proyecto-agenda-35b23.firebaseapp.com',
	FbProjectId: 'proyecto-agenda-35b23',
	FbDB: 'https://proyecto-agenda-35b23.firebaseio.com',
	FbStorage: 'proyecto-agenda-35b23.appspot.com'
	// FbUserApi: 'https://www.googleapis.com/identitytoolkit/v3/relyingparty/',
	// FbRefreshToken: 'https://securetoken.googleapis.com/v1/'
}

export default firebaseConf
